<div class="color-values-container">
  <mode-capra-search-input
    class="search-input"
    data-test="filter-search-input"
    placeholder="Search..."
    size="regular"
    [text]="searchTerm$ | async"
    (textChange)="onSearchTermChanged($event)"
  >
  </mode-capra-search-input>
  <cdk-virtual-scroll-viewport itemSize="24" class="value-list">
    <ng-container *cdkVirtualFor="let item of visibleListOfItems$; index as i; trackBy: trackByValue">
      <span
        class="value-row"
        [class.selected]="item.selected"
        (click)="onItemClick(item, $event)"
        (contextmenu)="onContextMenuClick(item, $event)"
      >
        <mode-color-swatch-flyout
          class="swatch"
          [activeColor]="item.colorHexCode"
          [selectedColorPalette]="selectedColorPalette"
          [allColorPalettes]="allColorPalettes"
          [vizToken]="vizToken"
          (colorUpdated)="onColorChanged($event, item.unformattedValue)"
        >
        </mode-color-swatch-flyout>
        <span
          class="value-label"
          [class.italics]="item.unformattedValue === null">{{ item.formattedValue }}</span>
        <div *ngIf="item.selected" class="menu-trigger-overlay" [cdkContextMenuTriggerFor]="context_menu"></div>
      </span>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>
<ng-template #context_menu>
  <div class="right-click-menu mat-menu-panel" cdkMenu>
    <button
      class="unassign-menu-item mat-menu-item"
      data-test="color-values-unassign-button"
      cdkMenuItem
      (click)="unassignSelected()"
    >
      Unassign color
    </button>
  </div>
</ng-template>
